import { getUnresolvedAsiAccessDecisionRefetchInterval, hasQuotaAccess, useAsiAccessDecision, } from '#pplx/frontend/apps/ask/hooks/computer-access-hooks/useAsiAccessDecision.js';
export const useQuotaEffortAccessState = ({ enabled = true, } = {}) => {
    const { data: decision } = useAsiAccessDecision({
        enabled,
        refetchInterval: (query) => getUnresolvedAsiAccessDecisionRefetchInterval(query.state.data),
    });
    const isLoading = enabled && decision == null;
    // Quota resets do not replenish credits, so exhaustion does not affect the Light restriction.
    const isRestricted = enabled && hasQuotaAccess(decision) && decision?.is_out_of_credits === true;
    return {
        isLoading,
        isRestricted,
        canEditPreferences: !isLoading && !isRestricted,
    };
};
//# sourceMappingURL=useQuotaEffortAccessState.js.map